import { developerToolsModuleQuery, useModule } from 'system/structure-modules';

export default function DeveloperToolsIndexScreen() {
    const { DeveloperToolsScreen } = useModule(developerToolsModuleQuery);
    return <DeveloperToolsScreen />;
}
